import { sizes } from "../constants/sizes";

import type { AvaPictureSizes } from "../types";

export const createOffsetClassMap = (
    prefix: string,
    classes: Record<string, string>,
): Record<AvaPictureSizes, string> => {
    const result: Record<AvaPictureSizes, string> = {} as Record<
        AvaPictureSizes,
        string
    >;

    sizes.forEach((size) => {
        result[size] = classes[`${prefix}-${size}`];
    });

    return result;
};
